import { render, staticRenderFns } from "./addsign.vue?vue&type=template&id=92e4bf0e"
import script from "./addsign.vue?vue&type=script&lang=js"
export * from "./addsign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports